// @stayai — generic, configurable selling-plan <option> hider for plain-DOM buyboxes/dropdowns.
// Not for a shadow-DOM vendor (verify per store, don't assume from vendor name).
// Config reference + worked examples: stay-scan-filter/techniques/generic-selling-plan-hider.md.
// Full rationale/incident history for this store's config: notes-stores/sprinkle.md.
//
// Configure via window.STAYAI_SELLING_PLAN_HIDER_CONFIGS (array; single object also accepted).
// Fields: widgetSelector, dropdownSelector (required); excludeSelector, activeAppId, hideTerms,
// plansDataGlobal, customLabel, debugFlag (optional) — see the doc above for full semantics.
//
// Prerequisite: theme must emit product.selling_plan_groups synchronously (never async-fetched)
// as window.ALL_SELLING_PLAN_GROUPS (or plansDataGlobal's name) wherever this widget renders.
(function () {
  var configs = window.STAYAI_SELLING_PLAN_HIDER_CONFIGS || window.STAYAI_SELLING_PLAN_HIDER_CONFIG;
  if (!configs) return;
  if (!Array.isArray(configs)) configs = [configs];

  configs.forEach(runWidget);

  function runWidget(config) {
    var ACTIVE_APP_ID = String(config.activeAppId || window.STAYAI_ACTIVE_APP_ID || '').trim();
    var HIDE_TERMS = (config.hideTerms || []).map(function (t) { return String(t).toLowerCase(); });
    var PLANS_GLOBAL = config.plansDataGlobal || 'ALL_SELLING_PLAN_GROUPS';
    var DEBUG_FLAG = config.debugFlag || 'STAYAI_SELLING_PLAN_HIDER_DEBUG';
    var DEBUG = window[DEBUG_FLAG] || false;

    if (!ACTIVE_APP_ID && !HIDE_TERMS.length) return; // nothing to filter by — no-op by design

    function log() {
      if (DEBUG) {
        console.log.apply(console, ['>>> [selling-plan-hider:' + config.widgetSelector + ']'].concat(Array.prototype.slice.call(arguments)));
      }
    }

    function matchesHiddenTerm(text) {
      var lower = String(text || '').toLowerCase();
      return HIDE_TERMS.some(function (term) {
        return lower.indexOf(term) !== -1;
      });
    }

    function buildMaps() {
      var groups = window[PLANS_GLOBAL] || [];
      var appIdMap = {};
      var hideByTermMap = {};
      groups.forEach(function (g) {
        (g.selling_plans || []).forEach(function (p) {
          appIdMap[String(p.id)] = g.app_id;

          var searchable = [g.name, p.name];
          (p.options || []).forEach(function (o) {
            searchable.push(o.name);
            searchable.push(o.value);
          });
          if (matchesHiddenTerm(searchable.join(' '))) {
            hideByTermMap[String(p.id)] = true;
          }
        });
      });
      return { appIdMap: appIdMap, hideByTermMap: hideByTermMap };
    }

    function filterSelect(select, maps) {
      // stayIrrelevant = permanent skip (no plan-id option ever seen). stayFiltered below is a
      // last-pass marker only, not a skip gate — see store notes for why.
      if (select.dataset.stayIrrelevant) return;
      var hasKnownOption = Array.prototype.some.call(select.options, function (opt) {
        return maps.appIdMap[opt.value] !== undefined || maps.hideByTermMap[opt.value] === true;
      });
      if (!hasKnownOption) {
        select.dataset.stayIrrelevant = 'true';
        return;
      }
      var selectedForeign = false;
      Array.prototype.slice.call(select.options).forEach(function (opt) {
        var appId = maps.appIdMap[opt.value];
        var hiddenByTerm = maps.hideByTermMap[opt.value] === true;
        var isForeign = !!ACTIVE_APP_ID && appId !== undefined && appId !== ACTIVE_APP_ID;
        var shouldHide = isForeign || hiddenByTerm;
        // disabled/hidden only — never opt.remove(); see store notes for the crash this caused.
        opt.disabled = shouldHide;
        opt.hidden = shouldHide;
        if (shouldHide) {
          if (opt.selected) selectedForeign = true;
          if (hiddenByTerm) log('hiding term-matched plan', opt.value, opt.textContent);
        }
      });
      if (selectedForeign || !select.value) {
        var fallback = select.querySelector('option:not([disabled])');
        if (fallback) {
          select.value = fallback.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          if (config.customLabel) {
            var wrapper = select.closest(config.customLabel.wrapperSelector);
            var label = wrapper && wrapper.querySelector(config.customLabel.labelSelector);
            if (label) label.textContent = fallback.dataset.sellingPlanName || fallback.textContent;
          }
        }
      }
      select.dataset.stayFiltered = 'true';
      log('filtered', select);
    }

    function scan(root, maps) {
      root.querySelectorAll(config.dropdownSelector).forEach(function (select) {
        if (config.excludeSelector && select.closest(config.excludeSelector)) return;
        filterSelect(select, maps);
      });
    }

    function init() {
      var root = document.querySelector(config.widgetSelector);
      if (!root) return;
      var maps = buildMaps();
      if (!Object.keys(maps.appIdMap).length && !Object.keys(maps.hideByTermMap).length) {
        log('no plan data / no matches found on window.' + PLANS_GLOBAL + ' — skipping');
        return;
      }
      scan(root, maps);
      var debounce; // debounced — see store notes for why
      new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () { scan(root, maps); }, 30);
      }).observe(root, { childList: true, subtree: true });
    }

    function waitForRoot(attempts) {
      var root = document.querySelector(config.widgetSelector);
      if (root) return init();
      if (attempts <= 0) return log('widget root "' + config.widgetSelector + '" never appeared — exiting');
      setTimeout(function () { waitForRoot(attempts - 1); }, 500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { waitForRoot(40); });
    } else {
      waitForRoot(40);
    }
  }
})();
